





















































































































































































































































































import {Component, Mixins, Watch} from 'vue-property-decorator';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import TaskContentMixin from '@/components/common/order/mixins/TaskContentList';
interface PageObj {
  page: number;
}

@Component({
  components: {CompSelectBox}
})
export default class TaskContentList extends Mixins(TaskContentMixin) {
  @Watch('showAllTask', {immediate: false, deep: true})
  showAllTaskChange(next: boolean) {
    this.handleShowAllTaskList(next);
  }
  @Watch('taskProcessNum', {immediate: false, deep: true})
  taskProcessNumChange(next: any): void {
    this.$emit('taskNumChange', next, this.taskTotalNum);
  }
  @Watch('taskTotalNum', {immediate: false, deep: true})
  taskTotalNumChange(next: any): void {
    this.$emit('taskNumChange', this.taskProcessNum, next);
  }

  public created(): void {}
  public mounted(): void {
    this.getTasks();
  }
  public destroyed(): void {}
  public replaceedContent(content){
    return content.replace(/(?:\r\n|\r|\n)/g, '<br>');
  }
}
